var render = function render(){var _vm=this,_c=_vm._self._c;return _c('client-only',[_c('photo-swipe',{attrs:{"is-open":_vm.photoSwipeIsOpen,"items":_vm.items,"options":_vm.photoSwipeOptions},on:{"gettingData":_vm.gettingData,"close":function($event){_vm.photoSwipeIsOpen = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }